import {path, propOr} from 'ramda';

import type {SimpleProductType} from 'constants/flow/flowTypesProduct';

import type {OptionType, EecProductDetailType} from 'libs/EEC/productToEECProductType';
import {getFrameSizeList, getSizeFrameShown} from 'libs/EEC/getFrame';
import {
    emptyByDefault,
    defaultOptions,
    size,
    getProductType,
    isGlasses as isGlassesHelper,
} from 'libs/EEC/productToEECProduct';
import {prepareBaseImpressionData} from 'libs/EEC/convertData/prepareData';
import {getName} from 'libs/EEC/getName';
import {getRegularPrice} from 'libs/EEC/getPrice';

import {getStockStatus} from '../getStock';

/**
 * Convert product to EEC product detail
 * @param {SimpleProductType} product - Product item
 * @param {OptionType} options - Options
 * @returns {EecProductDetailType} - EEC product item
 */
export const productsToEECDetailProducts = (
    product: SimpleProductType,
    options: OptionType = defaultOptions,
): EecProductDetailType => {
    const isGlasses = isGlassesHelper(options.type);
    const stockLevel = isGlasses ? {dimension11: getStockStatus(product)} : null;
    return {
        ...prepareBaseImpressionData(product, options),
        ...stockLevel,
        name: emptyByDefault(options.parentName || getName(product)),
        brand: emptyByDefault(path(['label'], options.brand)),
        dimension31: emptyByDefault(product.description).length,
        dimension34:
            propOr([], 'genders', product).join(',') ||
            propOr([], 'gender_label', product).join(','),
        dimension35: '',
        dimension36: getRegularPrice(product),
        dimension37: Number(options.reviews ? options.reviews.count : 0),
        dimension39: options.reviews ? options.reviews.rating : '0.0000',
        dimension40: getSizeFrameShown(options.colorsSizesList, product.id),
        dimension42: size(options.colorsSizesList),
        dimension43: size(getFrameSizeList(options.colorsSizesList)),
        dimension45: emptyByDefault(options.manufacturerValue),
        dimension60: getProductType(options.type, product.option_template),
    };
};
